import { render } from "./TablePagination.vue?vue&type=template&id=5c9820e2&scoped=true"
import script from "./TablePagination.vue?vue&type=script&lang=js"
export * from "./TablePagination.vue?vue&type=script&lang=js"

import "./TablePagination.vue?vue&type=style&index=0&id=5c9820e2&lang=scss&scoped=true"
import "./TablePagination.vue?vue&type=style&index=1&id=5c9820e2&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c9820e2"]])

export default __exports__